"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var eventTypeUtils_1 = require("seng-event/lib/util/eventTypeUtils");
var DataEvent_1 = require("./DataEvent");
var DeviceStateEvent = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceStateEvent, _super);
    function DeviceStateEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeviceStateEvent.prototype.clone = function () {
        return new DeviceStateEvent(this.type, this.data, this.bubbles, this.cancelable);
    };
    DeviceStateEvent.STATE_UPDATE = eventTypeUtils_1.EVENT_TYPE_PLACEHOLDER;
    return DeviceStateEvent;
}(DataEvent_1.default));
eventTypeUtils_1.generateEventTypes({ DeviceStateEvent: DeviceStateEvent });
exports.default = DeviceStateEvent;
